<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img
          src="http://static.xyb2b.com/images/326dcce731f32ed9084f659dae82c5b2.jpg"
          class="sidebar-logo"
        />
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img
          v-if="!showTitle"
          src="http://static.xyb2b.com/images/326dcce731f32ed9084f659dae82c5b2.jpg"
          class="sidebar-logo"
        />
        <h1 class="sidebar-title">{{ showTitle ? '' : title }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: '好店连连商户后台',
    };
  },
  computed: {
    ...mapGetters(['menuCodeList']),
    showTitle() {
      let status = true;

      if (this.menuCodeList.length <= 0) {
        return !status;
      }

      this.menuCodeList.some(item => {
        if (!['pay-manager', 'school-list-main', 'pay-list'].includes(item)) {
          status = false;
        }
      });
      return status;
    },
  },
  mounted() {
    console.log(this.menuCodeList, '22222');
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
      border-radius: 16px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
